import React from "react";
import { useHistory } from "react-router";
import { gql } from "@apollo/client";
import { Form } from "react-final-form";
import { Dialog } from "@syos-music/common";
import { InstrumentSelectField } from "@syos-music/instruments";
import { useMutation } from "@apollo/client";

import { Button, Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import IntlSlugField from "components/form/IntlSlugField";

const MUTATION = gql`
  mutation ($slug: IntlStringInput!) {
    CreateSignatureMouthpiece(slug: $slug) {
      signatureMouthpiece {
        id
      }
    }
  }
`;

export default function CreateSignatureMouthpiece({ children }) {
  const history = useHistory();

  const [isOpen, setIsOpen] = React.useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const [createSignatureMouthpiece] = useMutation(MUTATION);

  return (
    <>
      {children({ isOpen, open, close })}

      <Dialog open={isOpen} onClose={close}>
        <Form
          onSubmit={(values) =>
            createSignatureMouthpiece({ variables: values })
              .then(({ data }) => {
                close();
                const { signatureMouthpiece } = data.CreateSignatureMouthpiece;
                history.push(
                  `/signature-mouthpieces/${signatureMouthpiece.id}`
                );
              })
              .catch(() => true)
          }
          initialValues={{}}
          keepDirtyOnReinitialize
        >
          {({ handleSubmit, submitting, pristine, values }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              <Dialog.Title color="primary">
                Créer un bec signature
              </Dialog.Title>

              <Dialog.Content>
                <Grid container>
                  <Grid item xs={12}>
                    <InstrumentSelectField name="instrument" required />
                  </Grid>

                  {values.instrument && (
                    <Grid item xs={12}>
                      <IntlSlugField
                        name="slug"
                        prefix={`/shop/${values.instrument}/signature/`}
                        label="URL"
                        required
                      />
                    </Grid>
                  )}
                </Grid>
              </Dialog.Content>

              <Dialog.Actions>
                <Button variant="text" onClick={close}>
                  Annuler
                </Button>

                <LoadingButton
                  type="submit"
                  loading={submitting}
                  disabled={pristine}
                >
                  Créer
                </LoadingButton>
              </Dialog.Actions>
            </form>
          )}
        </Form>
      </Dialog>
    </>
  );
}
